import { __rest } from "tslib";
import React, { useCallback } from 'react';
import Modal from '@web-common/components/UI/Modal/SiriusModal';
import { useActions, useAppSelector, NiceModalActions } from '@web-common/state/createStore';
export const useNiceModal = (modalId) => {
    const { showModal, hideModal } = useActions(NiceModalActions);
    const show = useCallback((args) => {
        showModal({ modalId, args });
    }, [modalId]);
    const hide = useCallback((force) => {
        hideModal({ modalId, force });
    }, [modalId]);
    const args = useAppSelector(state => state.niceModalReducer[modalId]);
    const hiding = useAppSelector(state => state.niceModalReducer.hiding[modalId]);
    return { args, hiding, visible: !!args, show, hide };
};
export const createNiceModal = (modalId, Comp) => {
    return (props) => {
        const { visible, args } = useNiceModal(modalId);
        if (!visible)
            return null;
        return React.createElement(Comp, Object.assign({}, args, props));
    };
};
const NiceModal = props => {
    const { id, children } = props, rest = __rest(props, ["id", "children"]);
    const modal = useNiceModal(id);
    return (React.createElement(Modal, Object.assign({ onCancel: () => modal.hide(), onOk: () => modal.hide(), afterClose: () => modal.hide(true), visible: !modal.hiding }, rest), children));
};
export default NiceModal;
